export default function PendingItemBox(props) {
  return (
    <>
      <div
        {...props}
        className="w-full p-4 bg-white rounded-2xl shadow border border-primary50 flex-col justify-start items-center gap-[30px] inline-flex"
      >
        <div className="self-stretch justify-between gap-[13px] items-left flex flex-col">
          <div className="flex-col justify-start items-start flex">
            <p className="opacity-70 text-[#222222]/60 text-base font-normal  leading-normal">
              {props.title}
            </p>
          </div>
          <div className="flex justify-between">
            <h3 className="text-[#222222] text-3xl font-semibold  leading-9">
              {props.pendingcount}
            </h3>
            {props.children}
          </div>
        </div>
      </div>
    </>
  );
}
